<template>
  <div class="messageScreen">
    <div class="messageScreenBox">
      <div class="messageScreenImage"></div>
      <!-- <p class="messageScreenText">{{ loadingMessage }}</p> -->
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
// import { defineComponent ,computed } from 'vue'
// import { useStore } from 'vuex'

export default defineComponent({
  name: 'LoadingModal',
  setup () {
    // const store = useStore();
    // const loadingMessage = computed(() => store.getters.getLoadingMessage);

    return {
      // loadingMessage,
    }
  }
})
</script>